var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_17252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8698 18.0847L20.8013 17.5577L19.2488 11.6554L13.4527 13.2367L13.9711 15.2039L16.4677 14.5235L12.6992 21.1694L14.4313 22.1876L18.1998 15.5417L18.8698 18.0847Z",
    fill: "#4ECB71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0184 13.7916C25.446 7.8165 19.415 4.27119 13.5465 5.87223C7.67808 7.47326 4.19608 13.6139 5.76852 19.5891C7.34096 25.5642 13.372 29.1095 19.2404 27.5085C25.1089 25.9074 28.5909 19.7668 27.0184 13.7916ZM25.0869 14.3186C24.4691 11.9711 22.9607 9.96954 20.8935 8.75436C18.8263 7.53918 16.3697 7.20988 14.0641 7.83891C11.7585 8.46793 9.79267 10.0038 8.59919 12.1085C7.40571 14.2133 7.08229 16.7145 7.70008 19.0621C8.31787 21.4096 9.82627 23.4112 11.8934 24.6263C13.9606 25.8415 16.4172 26.1708 18.7229 25.5418C21.0285 24.9128 22.9943 23.377 24.1877 21.2722C25.3812 19.1674 25.7046 16.6662 25.0869 14.3186Z",
    fill: "#4ECB71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_17252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1098,
    height: 24.328,
    fill: "white",
    transform: "matrix(0.86208 0.506772 -0.493259 0.869883 12 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.2ea077377a9d4d9253670b11bbb083ca.svg";
export { ForwardRef as ReactComponent };